import React from "react";
import { css } from "@emotion/react";

import { SwarovskiHomepageLink } from "./subcomponents/SwarovskiLogoComponent";
import { SwarovskiLogoComponentWithChildren } from "./subcomponents/SwarovskiLogoComponentWithChildren";
import { ContentContainer } from "../_shared-components/arrangement/Container";
import { CSS_MQ } from "../../styles/breakpoints";
import { SwarovskiOptikLogotype } from "../../assets";
import { CSS_COLORS } from "../../styles/styles-css-variables";

export const MinimalisticHeadroomHeaderComponent: React.FC<{ homepageLink: SwarovskiHomepageLink }> = props => {
  const styles = css`
    position: absolute;
    margin: 16px auto;
    color: ${CSS_COLORS.Black};

    ${CSS_MQ.atMostMd} {
      svg {
        width: 40px;
        height: 49px;
      }
    }
  `;

  return (
    <ContentContainer
      css={css`
        position: relative;
      `}
    >
      <SwarovskiLogoComponentWithChildren homepageLink={props.homepageLink} attachStyles={styles}>
        <SwarovskiOptikLogotype />
      </SwarovskiLogoComponentWithChildren>
    </ContentContainer>
  );
};
